import React from "react";

const ArrowLightIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}>
			<path
				d="M14 7L8.92186 11.2318C8.44211 11.6316 8.44211 12.3684 8.92187 12.7682L14 17"
				stroke="#D9DBE9"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default ArrowLightIcon;
